import axios from "axios";

const getAll = (mawb) => {
  return axios
    .get(`/manifest/${mawb}/all`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const get = (id) => {
  return axios
    .get(`/manifest/${id}`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const update = (id, obj) => {
  return axios.put(`/manifest/${id}`, obj)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const getAllMAWBSelect = () => {
  return axios
    .get(`/manifest/mawb_select`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const downloadManifestReport = (mawb) => {
  return axios
    .get(`/manifest/${mawb}/download_manifest`, { responseType: 'blob' })
    .then(response => response)
    .catch(error => {
      throw error;
    });
}


export {
  getAll,
  get,
  update,
  getAllMAWBSelect,
  downloadManifestReport,
}
